import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3dcd7d22&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3dcd7d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd7d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcd7d22')) {
      api.createRecord('3dcd7d22', component.options)
    } else {
      api.reload('3dcd7d22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3dcd7d22&scoped=true&", function () {
      api.rerender('3dcd7d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/register/index.vue"
export default component.exports